import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowDown = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M12 8L8 12M8 12L4 8M8 12L8 3" stroke={color} />
    </svg>
  ),
)
ArrowDown.displayName = 'ArrowDown'
ArrowDown.defaultProps = {
  width: 16,
  height: 16,
}

export default ArrowDown
